module.exports = require('./helpers/bundle-url').getBundleURL('fJIW9') + "logo-dark.eefe0b7f.svg";